import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { ExternalLink } from "lucide-react";

export default function AvailabilityPage() {
  const [p, setP] = useState(null);
  useEffect(() => { http.get("/public/property").then((r) => setP(r.data.property)); }, []);
  if (!p) return null;
  return (
    <div>
      <PublicHeader />
      <div className="max-w-3xl mx-auto px-4 sm:px-8 py-16">
        <div className="eyebrow mb-3">Reserve</div>
        <h1 className="h1-hero text-5xl md:text-6xl mb-6">Check Availability</h1>
        <p className="mb-10" style={{ color: "var(--muted)" }}>
          Check live availability and book directly through our verified Airbnb listing, or contact us for a direct enquiry.
        </p>
        <div className="grid md:grid-cols-2 gap-5">
          <a href={p.airbnb_url} target="_blank" rel="noopener noreferrer" data-testid="availability-airbnb" className="card block">
            <div className="badge-terracotta mb-3 inline-block">Airbnb</div>
            <div className="font-serif text-2xl mb-2">Book on Airbnb</div>
            <p className="text-sm mb-4" style={{ color: "var(--muted)" }}>Instant confirmation with Airbnb guarantee.</p>
            <span className="inline-flex items-center gap-2 text-sm" style={{ color: "var(--terracotta)" }}>Open Airbnb listing <ExternalLink size={14} /></span>
          </a>
          {p.booking_com_url ? (
            <a href={p.booking_com_url} target="_blank" rel="noopener noreferrer" data-testid="availability-booking" className="card block">
              <div className="badge-pine mb-3 inline-block">Booking.com</div>
              <div className="font-serif text-2xl mb-2">Book on Booking.com</div>
              <p className="text-sm mb-4" style={{ color: "var(--muted)" }}>Flexible cancellation on Booking.com.</p>
              <span className="inline-flex items-center gap-2 text-sm" style={{ color: "var(--terracotta)" }}>Open Booking.com listing <ExternalLink size={14} /></span>
            </a>
          ) : (
            <a href={`tel:${p.phone.replace(/\s/g, "")}`} data-testid="availability-call" className="card block">
              <div className="badge-pine mb-3 inline-block">Direct Enquiry</div>
              <div className="font-serif text-2xl mb-2">Call the Host</div>
              <p className="text-sm mb-4" style={{ color: "var(--muted)" }}>Booking.com link coming soon — call us directly for now.</p>
              <span className="inline-flex items-center gap-2 text-sm" style={{ color: "var(--terracotta)" }}>{p.phone}</span>
            </a>
          )}
        </div>
        <div className="card mt-6">
          <div className="font-serif text-2xl mb-2">Prefer direct?</div>
          <p style={{ color: "var(--muted)" }} className="mb-3">WhatsApp us for a personalised quote — the owner replies directly.</p>
          <a href={`https://wa.me/${p.whatsapp.replace(/\D/g, "")}`} data-testid="availability-whatsapp" className="btn-primary inline-block">WhatsApp Host</a>
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
